/* Carnis – produktside (PDP) v1.5 (v1.5, okt. 2026: kjøpsvalgene er flyttet til carnis-kjop.js – initBuy brukes bare av eldre seksjoner;
   v1.4, okt. 2026: kjøpsboks v5 – totalpris i valgene og på knappen, pris per krukke
   og kilopris for valgt tilbud, sparing inkl. frakt, felles fri frakt-linje og fordeler under knappen; v1.1: abonnement under fri frakt-grensen viser ikke «fri frakt»;
   v1.2: planer som betales og sendes hver 3./6./12. mnd legger alle krukkene for perioden i kurven;
   v1.3: kompakt kjøpsboks (data-cpdp-compact): kjøpslinje også før kunden har nådd knappen,
   abonnementsfordeler under knappen og antall krukker i teksten under knappen)
   Kjøpsvelger (abonnement/engangskjøp), galleri, klebrig kjøpslinje og små animasjoner.
   Ingen avhengigheter. Fungerer sammen med temaets <product-form> (product-form.js). */
(function () {
  'use strict';

  // Tusenskille hentes fra butikkens money-format (moneySample i data-cpdp-config), så prisene fra Liquid og
  // prisene som oppdateres her ser like ut (f.eks. 1.096,50 kr). Hardt mellomrom før «kr».
  var MONEY_SEP = '.';
  function setMoneySample(sample) {
    var m = String(sample || '').match(/1(\D?)234(\D?)567/);
    if (m) MONEY_SEP = (m[1] === ' ' || m[1] === '') ? (m[1] === '' ? '' : ' ') : m[1];
  }
  function fmt(cents) {
    var v = Math.round(Number(cents) || 0);
    var kr = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, MONEY_SEP);
    var ore = ('0' + (v % 100)).slice(-2);
    return kr + ',' + ore + ' kr';
  }
  function fmtShort(cents) {
    var v = Math.round(Number(cents) || 0);
    if (v % 100 === 0) return Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, MONEY_SEP) + ' kr';
    return fmt(v);
  }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(root, sel, txt) { qsa(root, sel).forEach(function (el) { el.textContent = txt; }); }
  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  // Fjerner «fri frakt»-omtale fra en tekst (brukes når valgt abonnement er under fri frakt-grensen)
  function noShip(str) {
    return String(str || '').replace(/\s*(?:[·•|,–-]\s*|\bmed\s+)(?:alltid\s+)?fri frakt\b/gi, '').replace(/\s{2,}/g, ' ').trim();
  }

  /* ---------------- Galleri ---------------- */
  function initGallery(root) {
    var track = qs(root, '[data-cpdp-track]');
    if (!track) return;
    var slides = qsa(track, '[data-cpdp-slide]');
    var dots = qsa(root, '[data-cpdp-dot]');
    var thumbs = qsa(root, '[data-cpdp-thumb]');
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      track.dataset.index = i;
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = qs(root, '[data-cpdp-prev]'), next = qs(root, '[data-cpdp-next]');
    if (prev) prev.addEventListener('click', function () { go((+track.dataset.index || 0) - 1); });
    if (next) next.addEventListener('click', function () { go((+track.dataset.index || 0) + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        mark(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go((+track.dataset.index || 0) + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go((+track.dataset.index || 0) - 1); }
    });
    mark(0);
  }

  /* ---------------- Kjøpsvelger (v5) ----------------
     Totalpris i valgene og på knappen, pris per krukke (og kilopris) under valget, sparing inkl. frakt
     og én felles fri frakt-linje over knappen for både abonnement og engangskjøp. */
  function initBuy(root) {
    // v6 (okt. 2026): kjøpsvalgene ligger i snippets/carnis-kjop.liquid og styres av carnis-kjop.js
    if (qs(root, '[data-ck]')) return;
    var buy = qs(root, '[data-cpdp-buy]');
    if (!buy) return;
    var cfgEl = qs(root, '[data-cpdp-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }
    var t = cfg.text || {};
    setMoneySample(cfg.moneySample);
    var base = Number(cfg.base) || 0;
    var usesPerJar = Number(cfg.usesPerJar) || 20;
    var freeShip = Number(cfg.freeShip) || 0;
    var shipCost = Number(cfg.shipCost) || 0;
    var netWeight = Number(cfg.netWeight) || 0;
    var unit1 = t.unit1 || 'krukke', unitN = t.unitN || 'krukker';

    var form = qs(buy, 'form');
    var productForm = qs(buy, 'product-form');
    var inQty = qs(buy, '[data-cpdp-qty]');
    var inPlan = qs(buy, '[data-cpdp-sp]');
    var btn = qs(buy, '[data-cpdp-atc]');
    var btnLabel = qs(buy, '[data-cpdp-atc-label]');
    var modeInputs = qsa(buy, '[data-cpdp-mode]');
    var tierInputs = qsa(buy, '[data-cpdp-tier]');
    var perInputs = qsa(buy, '[data-cpdp-per]');
    var bundleInputs = qsa(buy, '[data-cpdp-bundle]');
    var opts = qsa(buy, '[data-cpdp-opt]');
    var shipbar = qs(buy, '[data-cpdp-shipbar]');
    var perkItems = qsa(buy, '[data-cpdp-perks] li');

    var state = {
      mode: (qs(buy, '[data-cpdp-mode]:checked') || {}).value || 'once',
      tier: qs(buy, '[data-cpdp-tier]:checked'),
      per: Number((qs(buy, '[data-cpdp-per]:checked') || {}).value || 1),
      bundle: qs(buy, '[data-cpdp-bundle]:checked')
    };

    if (!state.tier && tierInputs.length) {
      state.tier = tierInputs.filter(function (i) { return i.dataset.available === 'true'; })[0] || tierInputs[0];
      state.tier.checked = true;
    }
    if (!state.bundle && bundleInputs.length) { state.bundle = bundleInputs[0]; state.bundle.checked = true; }
    if (state.mode === 'sub' && !tierInputs.length) state.mode = 'once';

    function syncChecked(list) {
      list.forEach(function (i) { var l = i.closest('.cpdp-seg__item'); if (l) l.classList.toggle('is-checked', i.checked); });
    }
    function shipFor(total) { return (freeShip > 0 && total < freeShip) ? shipCost : 0; }
    function kgPrice(perJar) { return netWeight > 0 ? perJar * 1000 / netWeight : 0; }
    function unitLine(n, perJar) {
      var line = tpl(t.unitLine || '[jars] [unit] à [price]', { jars: n, unit: n === 1 ? unit1 : unitN, price: fmt(perJar) });
      var kg = kgPrice(perJar);
      if (kg > 0) line += tpl(t.kgPart || ' · [kg]/kg', { kg: fmt(kg) });
      return line;
    }
    // Sparing mot å kjøpe én krukke om gangen (abonnement: én i måneden) til vanlig pris, med frakt på hver bestilling
    function savings(n, total) {
      var product = Math.max(0, base * n - total);
      var ship = Math.max(0, shipFor(base) * n - shipFor(total));
      return { product: product, ship: ship, total: product + ship };
    }
    function saveDetail(sv, one) {
      var key = sv.product > 0 && sv.ship > 0 ? 'saveDetailBoth' : (sv.ship > 0 ? 'saveDetailShip' : 'saveDetailProduct');
      return tpl(t[key] || '', { product: fmtShort(sv.product), ship: fmtShort(sv.ship), one: one });
    }
    function paintShipbar(total, months) {
      if (!shipbar) return;
      var txt = qs(shipbar, '[data-cpdp-shipbar-text]');
      var fill = qs(shipbar, '[data-cpdp-shipbar-fill]');
      var free = shipFor(total) === 0;
      var msg;
      if (free) {
        msg = t.barFree || '';
      } else if (state.mode === 'sub') {
        var better = tierInputs.filter(function (i) { return Number(i.dataset.total) * state.per >= freeShip && (i.dataset.available === 'true' || cfg.designMode); })[0];
        msg = better ? tpl(t.barLeftSub, { ship: fmtShort(shipCost), months: better.dataset.months, left: fmtShort(freeShip - total), min: fmtShort(freeShip) })
                     : tpl(t.barLeftSubNone, { ship: fmtShort(shipCost), min: fmtShort(freeShip) });
      } else {
        msg = tpl(t.barLeftOnce, { left: fmtShort(freeShip - total), ship: fmtShort(shipCost), min: fmtShort(freeShip) });
      }
      if (txt) txt.textContent = msg;
      if (fill) fill.style.width = (free ? 100 : Math.max(4, Math.min(100, Math.round(total / freeShip * 100)))) + '%';
      shipbar.classList.toggle('is-free', free);
      perkItems.forEach(function (li) { if (li.hasAttribute('data-perk-free')) li.hidden = !free; });
    }

    function render() {
      opts.forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-cpdp-opt') === state.mode); });
      modeInputs.forEach(function (i) { i.checked = i.value === state.mode; });
      syncChecked(tierInputs); syncChecked(perInputs); syncChecked(bundleInputs);

      var summaryLabel, summaryValue, summarySmall, atc, fine, stickyMeta, selTotal = base;
      var unavailable = false;

      if (state.mode === 'sub' && state.tier) {
        var d = state.tier.dataset;
        var months = Number(d.months);
        var perJar = Number(d.per);
        var total = Number(d.total) * state.per;
        var jars = months * state.per;
        var list = base * jars;
        unavailable = d.available !== 'true';
        selTotal = total;
        var subShipFree = shipFor(total) === 0;
        setText(buy, '[data-cpdp-sub-total]', fmt(total));
        setText(buy, '[data-cpdp-sub-compare]', list > total ? fmt(list) : '');
        setText(buy, '[data-cpdp-sub-unit]', unitLine(jars, perJar));
        var sv = savings(jars, total);
        setText(buy, '[data-cpdp-sub-save]', tpl(t.saveSub, { save: fmtShort(sv.total), months: months, jars: jars, unit: unitN }));
        setText(buy, '[data-cpdp-sub-save-detail]', saveDetail(sv, t.oneSub || ''));
        qsa(buy, '[data-cpdp-sub-savebox]').forEach(function (el) { el.hidden = sv.total <= 0; });
        setText(buy, '[data-cpdp-perk-jars]', tpl(t.perkJars, { jars: jars, unit: jars === 1 ? unit1 : unitN }));
        summaryLabel = tpl(t.payNow, { months: months });
        summaryValue = fmt(total);
        summarySmall = tpl(subShipFree ? t.subSummary : (t.subSummaryNoShip || noShip(t.subSummary)), { jars: jars, per: state.per });
        atc = tpl(t.atcSub, { total: fmtShort(total) });
        fine = tpl((subShipFree ? t.subTerms : (t.subTermsNoShip || noShip(t.subTerms))) || '', { months: months, total: fmtShort(total), jars: jars });
        stickyMeta = tpl(subShipFree ? t.stickySub : (t.stickySubNoShip || noShip(t.stickySub)), { months: months, price: fmt(perJar), total: fmtShort(total), jars: jars });
        if (inPlan) { inPlan.value = d.plan || ''; inPlan.disabled = !d.plan; }
        // Betal og send hver periode (data-mult > 1): alle krukkene for perioden i kurven. Forhåndsbetalt: Shopify ganger opp selv.
        if (inQty) inQty.value = state.per * (Number(d.mult) > 1 ? Number(d.mult) : 1);
        var nudge = qs(buy, '[data-cpdp-nudge]');
        if (nudge) {
          var better = tierInputs.filter(function (i) { return Number(i.dataset.months) > months && (i.dataset.available === 'true' || cfg.designMode); })[0];
          if (better) {
            var extra = (perJar - Number(better.dataset.per)) * Number(better.dataset.months) * state.per;
            nudge.textContent = tpl(t.nudge, { months: better.dataset.months, pct: better.dataset.pct, save: fmtShort(extra), price: fmt(Number(better.dataset.per)) });
            nudge.hidden = false;
            nudge.dataset.target = better.value;
          } else { nudge.hidden = true; }
        }
        paintShipbar(total, months);
      } else {
        var b = state.bundle ? state.bundle.dataset : { qty: 1, pct: 0 };
        var qty = Number(b.qty) || 1;
        var pct = Number(b.pct) || 0;
        var tot = Math.round(base * qty * (100 - pct) / 100);
        selTotal = tot;
        setText(buy, '[data-cpdp-once-price]', fmt(tot));
        qsa(buy, '[data-cpdp-once-compare]').forEach(function (el) { el.textContent = pct > 0 ? fmt(base * qty) : ''; el.hidden = pct <= 0; });
        setText(buy, '[data-cpdp-once-unit]', unitLine(qty, tot / qty));
        var svo = savings(qty, tot);
        setText(buy, '[data-cpdp-once-save]', tpl(t.saveOnce, { save: fmtShort(svo.total), jars: qty, unit: qty === 1 ? unit1 : unitN }));
        setText(buy, '[data-cpdp-once-save-detail]', saveDetail(svo, t.oneOnce || ''));
        qsa(buy, '[data-cpdp-once-savebox]').forEach(function (el) { el.hidden = qty < 2 || svo.total <= 0; });
        summaryLabel = t.payOnce || '';
        summaryValue = fmt(tot);
        summarySmall = tpl(freeShip > 0 && tot >= freeShip ? t.onceSummaryFree : t.onceSummary, { qty: qty });
        atc = tpl(t.atcOnce, { total: fmtShort(tot) });
        stickyMeta = tpl(t.stickyOnce, { qty: qty, price: fmt(tot) });
        if (inPlan) { inPlan.value = ''; inPlan.disabled = true; }
        if (inQty) inQty.value = qty;
        fine = tot >= freeShip && freeShip > 0 ? (t.onceFineFree || '') : (t.onceFine || '');
        paintShipbar(tot, 0);
      }

      perkItems.forEach(function (li) {
        var m = li.getAttribute('data-perk-mode');
        if (m) li.hidden = m !== state.mode;
      });

      setText(root, '[data-cpdp-summary-label]', summaryLabel);
      setText(root, '[data-cpdp-summary-value]', summaryValue);
      setText(root, '[data-cpdp-summary-small]', summarySmall);
      setText(root, '[data-cpdp-fine]', fine);
      setText(root, '[data-cpdp-sticky-meta]', stickyMeta);
      if (btnLabel) btnLabel.textContent = atc;
      setText(root, '[data-cpdp-sticky-label]', state.mode === 'sub' ? (t.stickyBtnSub || atc) : (t.stickyBtnOnce || atc));
      var note = qs(buy, '[data-cpdp-unavailable]');
      if (note) note.hidden = !(state.mode === 'sub' && unavailable);
      if (btn) btn.toggleAttribute('data-cpdp-blocked', state.mode === 'sub' && unavailable);
      buy.dataset.mode = state.mode;
      buy.dataset.total = selTotal;
    }

    modeInputs.forEach(function (i) { i.addEventListener('change', function () { if (i.checked) { state.mode = i.value; render(); } }); });
    tierInputs.forEach(function (i) { i.addEventListener('change', function () { if (i.checked) { state.tier = i; state.mode = 'sub'; render(); } }); });
    perInputs.forEach(function (i) { i.addEventListener('change', function () { if (i.checked) { state.per = Number(i.value) || 1; render(); } }); });
    bundleInputs.forEach(function (i) { i.addEventListener('change', function () { if (i.checked) { state.bundle = i; state.mode = 'once'; render(); } }); });

    var nudgeBtn = qs(buy, '[data-cpdp-nudge]');
    if (nudgeBtn) nudgeBtn.addEventListener('click', function () {
      var target = tierInputs.filter(function (i) { return i.value === nudgeBtn.dataset.target; })[0];
      if (target) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    // Før temaets product-form sender skjemaet: rydd bort eventuelle app-injiserte selling_plan-felt
    if (productForm && form) {
      productForm.addEventListener('submit', function (e) {
        if (btn && btn.hasAttribute('data-cpdp-blocked')) {
          e.preventDefault(); e.stopImmediatePropagation();
          var note = qs(buy, '[data-cpdp-unavailable]');
          if (note) { note.hidden = false; note.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
          return;
        }
        qsa(form, '[name="selling_plan"]').forEach(function (el) { if (el !== inPlan) el.parentNode.removeChild(el); });
        if (inPlan) inPlan.disabled = !(state.mode === 'sub' && inPlan.value);
      }, true);
    }

    // Eksterne knapper (f.eks. i andre seksjoner): data-cpdp-choose="sub:6" / "once:1"
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-cpdp-choose]') : null;
      if (!a) return;
      var parts = (a.getAttribute('data-cpdp-choose') || '').split(':');
      if (parts[0] === 'sub' && parts[1]) {
        var ti = tierInputs.filter(function (i) { return i.value === parts[1]; })[0];
        if (ti) { ti.checked = true; state.tier = ti; }
        state.mode = 'sub';
      } else if (parts[0] === 'once') {
        var bi = bundleInputs.filter(function (i) { return i.dataset.qty === parts[1]; })[0];
        if (bi) { bi.checked = true; state.bundle = bi; }
        state.mode = 'once';
      }
      render();
      var target = document.getElementById('carnis-buy');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    render();

    /* Klebrig kjøpslinje. Med data-cpdp-compact vises den også før kunden har nådd kjøpsknappen
       («Kjøp nå» tar kunden ned til valgene), og skjules mens selve knappen er synlig. */
    var sticky = qs(root, '[data-cpdp-sticky]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      var compact = root.hasAttribute('data-cpdp-compact');
      var footerSeen = false;
      var atcSeen = true, atcAbove = false;
      var paintSticky = function () {
        var show = !atcSeen && (atcAbove || compact) && !footerSeen;
        sticky.classList.toggle('is-visible', show);
        sticky.classList.toggle('is-intro', compact && !atcAbove);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          atcSeen = en.isIntersecting;
          atcAbove = en.boundingClientRect.top < 0;
        });
        paintSticky();
      }, { threshold: 0 });
      io.observe(btn);
      var footer = document.querySelector('footer, .footer, [id*="footer"]');
      if (footer) {
        new IntersectionObserver(function (en) {
          footerSeen = en[0].isIntersecting;
          if (footerSeen || compact) paintSticky();
        }).observe(footer);
      }
      var toBuy = function () { document.getElementById('carnis-buy').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      var sbtn = qs(sticky, '[data-cpdp-sticky-btn]');
      if (sbtn) sbtn.addEventListener('click', function () {
        if (sticky.classList.contains('is-intro')) { btn.scrollIntoView({ behavior: 'smooth', block: 'end' }); return; }
        if (form && typeof form.requestSubmit === 'function') {
          if (btn.hasAttribute('data-cpdp-blocked')) { document.getElementById('carnis-buy').scrollIntoView({ behavior: 'smooth' }); return; }
          form.requestSubmit(btn);
        } else if (btn) { btn.click(); }
      });
      var schange = qs(sticky, '[data-cpdp-sticky-change]');
      if (schange) schange.addEventListener('click', toBuy);
    }
  }

  /* ---------------- Pakketilbud under knappen (Carnis-pakken) ----------------
     Malen #cpk-cross-v2-tpl kommer fra snippets/carnis-pakke-kurv-global.liquid. Kortet settes inn etter
     fordelene under kjøpsknappen, og «Oppgrader»-knappen legger pakken (engangskjøp) rett i handlekurven. */
  function initCross(root) {
    var tplEl = document.getElementById('cpk-cross-v2-tpl');
    var buy = qs(root, '[data-cpdp-buy]');
    if (!tplEl || !tplEl.content || !buy || qs(buy, '[data-cpx]')) return;
    var anchor = qs(buy, '[data-cpdp-perks]') || qs(buy, '[data-cpdp-fine]') || qs(buy, 'product-form');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(tplEl.content.cloneNode(true), anchor.nextSibling);
    var box = qs(buy, '[data-cpx]');
    var btn = box ? qs(box, '[data-cpx-add]') : null;
    if (!btn) return;
    btn.addEventListener('click', function () {
      var err = qs(box, '[data-cpx-err]');
      var drawer = document.querySelector('cart-drawer');
      var sections = [];
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
      }
      var routes = window.routes || {};
      btn.disabled = true; btn.classList.add('is-busy');
      if (err) err.hidden = true;
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart'); return j; });
      }).then(function (j) {
        try {
          // PUB_SUB_EVENTS er en const i pubsub.js (ikke en egenskap på window)
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carnis-pakketilbud', productVariantId: btn.getAttribute('data-variant'), cartData: j });
          }
        } catch (e) {}
        if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
          drawer.renderContents(j);
        } else {
          window.location.href = routes.cart_url || '/cart';
        }
      }).catch(function () {
        if (err) err.hidden = false;
      }).then(function () {
        btn.disabled = false; btn.classList.remove('is-busy');
      });
    });
  }

  /* ---------------- Røykpunkt-animasjon ---------------- */
  function initBars() {
    var lists = qsa(document, '[data-cpdp-bars]');
    if (!lists.length) return;
    if (!('IntersectionObserver' in window)) { lists.forEach(function (l) { l.classList.remove('is-pending'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('is-pending'); io.unobserve(en.target); } });
    }, { threshold: 0.35 });
    lists.forEach(function (l) { io.observe(l); });
  }

  function boot() {
    qsa(document, '[data-cpdp-main]').forEach(function (root) {
      if (root.dataset.cpdpReady) return;
      root.dataset.cpdpReady = '1';
      initGallery(root);
      initBuy(root);
      initCross(root);
    });
    initBars();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
